module.exports = __webpack_public_path__ + "img/header.05786c53.png";